import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ElDatePicker } from 'element-plus';
import {useGettext} from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'DateRangeSelect',
  props: /*@__PURE__*/_mergeModels({
    disabled: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const { $gettext } = useGettext();

// Props


// Disable dates in the past
const validateDate = (date: Date) => {
    const today = new Date();
    return date.getTime() < today.getTime() - 24 * 60 * 60 * 1000;
};

// Store the value
const value = _useModel<string[]>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ElDatePicker), {
      class: "date-picker",
      "popper-class": "date-picker-popper",
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      type: "daterange",
      "start-placeholder": _unref($gettext)('Start date'),
      "end-placeholder": _unref($gettext)('End date'),
      clearable: false,
      "disabled-date": validateDate,
      disabled: _ctx.disabled
    }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "disabled"])
  ]))
}
}

})